/**
 * Utility functions for Activity Cards
 * Shared formatting and display logic to avoid duplication across activity card components
 */

/**
 * Format a date range for display in activity cards
 * @example formatDateRange("2026-05-15", "2026-05-18") → "May 15 - 18"
 */
export const formatDateRange = (start_date: string, end_date: string): string => {
  const start = new Date(start_date);
  const end = new Date(end_date);
  
  const startMonth = start.toLocaleDateString('en-US', { month: 'short' });
  const startDay = start.getDate();
  const endDay = end.getDate();
  
  return `${startMonth} ${startDay} - ${endDay}`;
};

/**
 * Format time string by removing seconds
 * @example formatActivityTime("14:30:00") → "14:30"
 */
export const formatActivityTime = (time: string): string => {
  return time.slice(0, 5);
};

/**
 * Check if a cost should be visible based on user permissions
 */
export const shouldShowCost = (
  cost: number | null | undefined,
  isAdmin: boolean,
  isTraveler: boolean
): boolean => {
  return cost !== null && cost !== undefined && cost > 0 && (isAdmin || !isTraveler);
};

/**
 * Check if a link should be visible based on user permissions
 */
export const shouldShowLink = (
  link: string | null | undefined,
  isAdmin: boolean,
  isTraveler: boolean
): boolean => {
  return !!link && (isAdmin || !isTraveler);
};
